var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;
return _c('v-app', [_c('app-header'), _vm._v(" "), _c('v-main', [_c('v-container', {
    staticClass: "align-baseline d-flex"
  }, [_c('nuxt')], 1), _vm._v(" "), _c('app-footer')], 1), _vm._v(" "), _c('app-scroll-to-top'), _vm._v(" "), _c('app-snack-bar-messages')], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }